import { render, staticRenderFns } from "./PersonalTabBar.vue?vue&type=template&id=0cb27e94&"
import script from "./PersonalTabBar.vue?vue&type=script&lang=js&"
export * from "./PersonalTabBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports